@if ({ groupVariants: groupVariants$ | async, showImgOverflow: showImgOverflow$
| async, showImgFullSpace: showImgFullSpace$ | async, useThumbnailsSkeleton:
useThumbnailsSkeleton$ | async, enableProgressiveImageLoad:
enableProgressiveImageLoad$ | async, extendedDabItemsEnabled:
extendedDabItemsEnabled$ | async, dabItemsHovered: dabItemsHovered$ | async,
isMobile: isMobile$ | async, showMarkup: showMarkup$ | async, showIconsOnHover:
showIconsOnHover$ | async, showPopularityIcon: showPopularityIcon$ | async,
dabInBasketData: dabInBasketData$ | async, dabData: dabData$ | async }; as ctx)
{ @if (product) {
<atx-card
  class="pcard h-100 border-0 position-relative"
  [class.compact-view]="compactView"
  [style.box-shadow]="showFrameLabel() && productFrameLabelShadow() | safeStyle"
>
  <div
    class="product-card-header"
    [ngClass]="{
      'pt-2': ctx.showImgFullSpace && showProductTitle,
      'pt-0': !showProductTitle
    }"
  >
    <epc-product-card-header
      [product]="product"
      [showMarkup]="ctx.showMarkup"
      [prices]="prices"
      [compactView]="compactView"
      [isSearchV2Enabled]="isSearchV2Enabled"
      [showProductTitle]="showProductTitle"
      (click)="clickCard()"
    ></epc-product-card-header>
  </div>
  <div
    class="product-card-subheader"
    [class.visible-on-hover]="ctx.showIconsOnHover && !compactView"
    [class.pb-2]="ctx.showImgFullSpace"
    (click)="clickCard()"
  >
    <div class="absolute-wrapper">
      @if(showIcons()) { @for (attribute of productLabelAttributeKeys$ | async;
      track attribute) { @if (isAttributeTrue(product.attributes[attribute])) {
      <atx-badge class="badge bg-primary text-white rounded-pill">{{
        productLabelTranslationKeys[attribute]
      }}</atx-badge>
      } } @if (!compactView) { @if (hasIconsIndicators()) {
      <atx-product-labels [productLabels]="product.labels" [location]="'top'">
      </atx-product-labels>
      }

      <epc-product-card-icons
        [product]="product"
        [showPopularityIcon]="
          ctx.showPopularityIcon && isPopularityIconVisible()
        "
        [showNewIcon]="isNewIconVisible()"
        [showGenderIcon]="isGenderIconVisible()"
        [showMraIcon]="isMraIconVisible()"
        data-e2e="pcard-icons"
        class="flex-1"
      >
      </epc-product-card-icons>
      } } @if (showActions) {
      <epc-product-card-actions
        [product]="product"
        [deletable]="deletable"
        [currentVariantMedia]="currentVariantMedia"
        [bookMarkNextAvailableVariant]="bookMarkNextAvailableVariant"
        [showBookmarkIcon]="showBookmarkIcon"
        (click)="$event.stopPropagation()"
        data-e2e="pcard-actions"
        class="flex-shrink-0"
      >
      </epc-product-card-actions>
      }
    </div>
  </div>
  <div
    class="card-container"
    *ngrxLet="
      productImageMissingVisualConfig$
        | async as productImageMissingVisualConfig
    "
  >
    <atx-carousel-card
      class="carousel mw-100"
      (clickedMainImage)="clickCard()"
      (clickedVariant)="updateCurrentVariant($event)"
      [items]="getCarouselItems(ctx.groupVariants)"
      [moreImagesIndicatorTooltip]="getCarouselToolTip(ctx.groupVariants)"
      [imageBreakpoints]="imageBreakpoints"
      [carouselBreakpoints]="carouselBreakpoints"
      [showMoreImagesIndicator]="ctx.showImgOverflow"
      [thumbnailsNumber]="thumbnailsNumber"
      [thumbnailsVisible]="!compactView"
      [fullSpace]="ctx.showImgFullSpace"
      [useThumbnailsSkeleton]="ctx.useThumbnailsSkeleton"
      [progressiveImageLoad]="ctx.enableProgressiveImageLoad"
      [initialBodyImageUrl]="
        ctx.groupVariants && product.articleImageUrl
          ? product.articleImageUrl
          : undefined
      "
      placeholderImage="static/images/placeholder-image.jpg"
      borderRadius="true"
      [mayUseMissingImageContent]="productImageMissingVisualConfig.enabled"
      [missingImageTemplate]="missingImageTemplate"
      [zoomFactorThubmailMissingImage]="
        productImageMissingVisualConfig.thumbnailZoomFactor ?? 2
      "
      [currentVariantMedia]="currentVariantMedia"
      (toggledHover)="dabItemsHovered$.next($event)"
    >
      <section class="carousel-card-info dab-items-container"></section>
      <ng-template #missingImageTemplate let-currentIndex>
        <atx-product-image-missing-visual
          class="w-100 h-100"
          missingImageContent
          [product]="getProduct(currentIndex)"
          [svg]="productImageMissingVisualConfig.svg"
          [replacementInstructions]="
            productImageMissingVisualConfig.replacementInstructions
          "
        >
        </atx-product-image-missing-visual>
      </ng-template>
    </atx-carousel-card>
    @if (showIcons()) {
    <div class="position-absolute icon-indicators">
      @if (discountVisible) {
      <atx-discount-label
        *atxCanShowByWsp
        class="d-block badge-success mb-2"
        [discount]="discount"
      ></atx-discount-label>
      } @if (hasIconsIndicators()) {
      <atx-product-labels [productLabels]="product.labels">
      </atx-product-labels>
      } @if (checkIfProductIsMarketing(product.productId) | async) {
      <atx-marketing-badge></atx-marketing-badge>
      }
    </div>
    } @if (!compactView) { @if (ctx.extendedDabItemsEnabled) {
    <div
      class="dabs-items-animated-container overflow-hidden"
      (click)="clickCard()"
    >
      <ng-container *ngTemplateOutlet="extendedDabList"></ng-container>
    </div>
    @if (ctx.dabItemsHovered) {
    <div @fadeInOut>
      <ng-container *ngTemplateOutlet="minifiedDabList"></ng-container>
    </div>
    } } @else {
    <div class="product-dabs d-flex align-items-center justify-content-center">
      <ng-container
        *ngTemplateOutlet="dabList; context: { extendedView: false }"
      ></ng-container>
    </div>
    } }
  </div>
  @if (isDraggable) {
  <div
    class="drag-container hover-show d-flex justify-content-center align-items-center"
    [class.invisible]="showProductDetails === false && ctx.isMobile === false"
  >
    <ng-container [ngTemplateOutlet]="dragAndDropHandleTemplate"></ng-container>
  </div>
  }
</atx-card>
}

<div class="unavailable-message-wrapper">
  <span
    class="py-1 out-of-stock-label"
    i18n="PCard|Product not available message on pcard@@pcardProductOutOfStock"
  >
    Out of stock
  </span>
  @if (expandingUnavailableProductCardEnabled$ | async) {
  <div class="d-none d-sm-block show-similar-product mt-5">
    <button
      class="btn btn-primary pointer-events-auto"
      (click)="expandSimilarProducts()"
      i18n="PCard|Similar products button@@similarProductsButton"
    >
      Similar products
    </button>
  </div>
  }
  <div class="unavailable-delete-container">
    @if (showUnavailableDeleteButton) {
    <button
      data-e2e="drag-and-drop-btn"
      class="dnd-icon-holder btn btn-light btn-round pointer-events-auto"
      (click)="deleteFromProductList(product)"
    >
      <fa-icon [icon]="['fas', 'trash']" class="dnd-icon"></fa-icon>
    </button>
    }
  </div>
</div>

<ng-template #dabList let-extendedView="extendedView">
  @if (ctx.dabInBasketData; as inBasket) {
  <atx-product-dab-item
    [type]="inBasket.type"
    [quantity]="inBasket.quantity"
    [text]="inBasket.text"
    [extendedView]="extendedView"
  >
  </atx-product-dab-item>
  } @for (dab of ctx.dabData; track trackDabItem($index, dab)) {
  <div>
    <atx-product-dab-item
      [type]="dab.type"
      [quantity]="dab.quantity"
      [text]="dab.text"
      [extendedView]="extendedView"
    >
    </atx-product-dab-item>
  </div>
  }
</ng-template>
<ng-template #extendedDabList>
  <div [@slideDown]="ctx.dabItemsHovered === true ? 'down' : 'full'">
    <ng-container
      *ngTemplateOutlet="dabList; context: { extendedView: true }"
    ></ng-container>
  </div>
</ng-template>
<ng-template #minifiedDabList>
  <div class="product-dabs d-flex align-items-center justify-content-center">
    <ng-container
      *ngTemplateOutlet="dabList; context: { extendedView: false }"
    ></ng-container>
  </div>
</ng-template>
}
